export const WORKSHOP_ROLE_IDS = ['3', '4', '5', '6', '7', '8'];
export const SITE_ROLE_IDS = ['9'];

export const schema = (userRoles) => ({
  // required: ['role_id'],
  type: 'object',
  properties: {
    role_id: {
      type: 'string',
      title: 'role',
      // oneOf: userRoles,
    },
  },
  allOf: [
    // {
    //   if: {
    //     properties: {
    //       role_id: {},
    //     },
    //   },
    //   then: {
    //     not: {
    //       properties: {
    //         workshop_id: {},
    //         site_id: {},
    //       },
    //     },
    //   },
    // },
    {
      if: {
        required: ['role_id'],
        properties: {
          role_id: {
            enum: WORKSHOP_ROLE_IDS,
          },
        },
      },
      then: {
        required: ['workshop_id'],
        properties: {
          workshop_id: {
            type: 'array',
            title: 'workshop',
            items: {
              type: 'string',
            },
          },
        },
      },
    },
    {
      if: {
        required: ['role_id'],
        properties: {
          role_id: {
            enum: SITE_ROLE_IDS,
          },
        },
      },
      then: {
        required: ['site_id'],
        properties: {
          site_id: {
            type: 'string',
            title: 'site',
          },
        },
      },
    },
    {
      required: ['role_id'],
    },
  ],
});
